export default __webpack_public_path__ + "static/media/image-slider-2.07770d85.png";